export default class Navigation {

  static get NAVIGATION_HAPPEND() {
    return 'eform-frontend-navigation-happened'
  }

  constructor() {
    window.onhashchange = _ => window.send(Navigation.NAVIGATION_HAPPEND, getNavigationHash())
  }
}
const navigation = new Navigation()
